import { render, staticRenderFns } from "./DashboardItemsHeader.vue?vue&type=template&id=62e62af2&scoped=true&"
import script from "./DashboardItemsHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardItemsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardItemsHeader.vue?vue&type=style&index=0&id=62e62af2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e62af2",
  null
  
)

export default component.exports